import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';

export function ChallengeBewertung({ lobbyId, teamIds, teams }: { lobbyId: string; teamIds: string[]; teams: {id:string;name:string}[] }) {
  const [runs, setRuns] = useState<{id:string;state:string;openedAt:string}[]>([]);
  const [results, setResults] = useState<{runId:string;teamId:string;passed:boolean}[]>([]);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    const data = await api.winChallengeResults(lobbyId);
    setRuns(data.runs); setResults(data.results);
  }, [lobbyId]);
  useEffect(() => { void load().catch(() => {}); }, [load]);
  const closed = runs.filter(run => run.state === 'CLOSED').slice(-5).reverse();
  return <details className="panel" style={{ display: "block" }}>
    <summary style={{ cursor: "pointer", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: "0.8rem", padding: "0.15rem 0" }}>Meine Challenge-Ergebnisse</summary>
    <p className="muted small">Bewerte abgeschlossene Challenge-Umfragen für dein Team. Du kannst einen Status korrigieren. Pro Umfrage zählt ein Erfolg höchstens einmal.</p>
    {closed.length === 0 && <p className="muted small">Noch keine abgeschlossenen Challenge-Umfragen.</p>}
    {closed.map(run => <div key={run.id} className="row">
      <span>Umfrage vom {new Date(run.openedAt).toLocaleString('de-DE')}</span>
      {teamIds.map(teamId => {
        const result = results.find(r => r.runId === run.id && r.teamId === teamId);
        return <label key={teamId}>{teams.find(t => t.id === teamId)?.name ?? 'Team'}
          <select disabled={busy} value={result ? (result.passed ? 'yes' : 'no') : ''} onChange={async event => {
            if (!event.target.value) return;
            setBusy(true); setError('');
            try { await api.winChallengeResult(lobbyId, run.id, teamId, event.target.value === 'yes'); await load(); }
            catch (err) { setError(err instanceof Error ? err.message : 'Bewertung fehlgeschlagen.'); }
            finally { setBusy(false); }
          }}>
            <option value="">Nicht bewertet</option>
            <option value="yes">Bestanden</option>
            <option value="no">Nicht bestanden</option>
          </select>
        </label>;
      })}
    </div>)}
    {error && <p role="alert" className="notice">{error}</p>}
  </details>;
}
